<template>
    <div class="icon" v-html="require('!html-loader!./../assets/icons/' + filename + '.svg')">
    </div>
</template>

<script>
    export default {
        name: "Icon",
        props: ['filename'],

    }
</script>

<style lang="less">
    @import "../variables.less";
    .icon > svg {
        width: auto;
        height: 40px;
        max-width: 100%;
        max-height: 40px;
    }

    .icon.small-icon > svg {
        height: 25px;
        max-height: 25px;
    }

    .icon.small-icon {
        display: inline-block;
    }

    .active .icon path {
        fill: @accent-bright !important;
    }
</style>
